import { useMutation, useQuery } from "@tanstack/react-query";
import { useRecipeKeys } from "./useRecipeKeys";
import { getRecipeBasicDetails, downloadRecipeApi } from "../api/RecipeApi";
import { errorMessage, printFile } from "../../../utils";

export const useBasicDetailsQueries = ({ recipeId }) => {
  const { recipeKeys } = useRecipeKeys();
  const basicDetailsQuery = useQuery({
    queryKey: recipeKeys.detailBykEY("basic_details", recipeId),
    queryFn: () => getRecipeBasicDetails(recipeId),
    enabled: recipeId > 0,
  });

  const downloadRecipe = useMutation({
    mutationFn: ({ recipeId }) => downloadRecipeApi(recipeId),
    onError: (error) => {
      errorMessage(error?.response?.data?.message || "Download failed");
    },
    onSuccess: (res, variables) => {
      printFile(res.data);
      if (variables?.handleModal) variables.handleModal();
    },
  });

  return { basicDetailsQuery, downloadRecipe };
};
